export const images = {
    downloadArrow: require("../assets/arrow_downward.png"),
    qr_default: require("../assets/qr_default.png"),
    chileTicketFooter: require("../assets/chileTicketLogo.png")
}